
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/retainers",
      function () {
        return require("private-next-pages/[lng]/retainers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/retainers"])
      });
    }
  